export default __webpack_public_path__ + "images/wallet-icon.png?310b887b";